import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=23769591&scoped=true&"
import script from "./ProductGallery.vue?vue&type=script&lang=js&"
export * from "./ProductGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23769591",
  null
  
)

export default component.exports